<template>
    <div class="billcycle-pack account-period">
        <rcTable ref="rcTable"
                 :checkPms="hasPermission('CC030301')"
                 :tableAttr="tableAttr">
            <div slot="tootipL">
                <Button @click="refresh"
                        v-if="hasPermission('CC030301')">
                    <i class="icon-refresh-o"></i>
                </Button>
                <Button @click="exportData"
                        v-if="hasPermission('CC030302')"
                        :disabled="loading">
                    <i class="icon-export-1-o"
                       style="vertical-align: middle;"></i>
                    {{$t('导出')}}
                </Button>
                <Button @click="downloadTask"
                        v-if="hasPermission('CC030302')"
                        :disabled="loading">
                    {{$t('下载任务')}}
                </Button>
            </div>
            <template v-if="hasPermission('CC030301')">
                <Form ref="form"
                      slot="tootipR"
                      inline
                      :model="formData"
                      :rules="rules"
                      :label-colon="true"
                      :label-width="75">
                    <FormItem :label="$t('开始时间')"
                              prop="startTime"
                              style="margin-bottom: 0px;">
                        <DatePicker v-model="formData.startTime"
                                    type="month"
                                    :editable='false'
                                    placement="bottom-end"
                                    :placeholder="$t('开始时间')"
                                    transfer
                                    confirm
                                    @on-clear="clearDate"
                                    @on-ok="submit"
                                    style="width: 100px" />
                    </FormItem>
                    <FormItem :label="$t('结束时间')"
                              prop="endTime"
                              style="margin-bottom: 0px;">
                        <DatePicker v-model="formData.endTime"
                                    type="month"
                                    :editable='false'
                                    placement="bottom-end"
                                    :placeholder="$t('结束时间')"
                                    transfer
                                    confirm
                                    @on-clear="clearDate"
                                    @on-ok="submit"
                                    style="width: 100px" />
                    </FormItem>
                </Form>
            </template>
        </rcTable>
    </div>
</template>
<script>
import rcTable from '@/views/components/basic/rcTable'
import API from '@/service/api'
import { getNextOrPreMonth, formatDateTime } from '@/service/utils'
export default {
    name: 'accountPeriod',
    components: {
        rcTable
    },
    props: {
        searchColumns: Array,
        columns: Array
    },
    data () {
        const validStartTime = (rule, value, callback) => {
            const { endTime } = this.formData
            if (!value) {
                callback()
            } else {
                if (!endTime) {
                    this.$refs.form.validateField('endTime')
                }
                callback()
            }
        }
        const validEndTime = (rule, value, callback) => {
            const { startTime } = this.formData
            if (!value || !startTime) {
                callback()
            } else {
                const validEndTime = getNextOrPreMonth(startTime, 3)
                if (+value > (+new Date(`${validEndTime} 00:00:00`) - 1000)) {
                    callback(this.$t('所选账期超过三个月'))
                }
                if (+value < +startTime) {
                    callback(this.$t('不能早于开始时间'))
                }
                callback()
            }
        }
        return {
            loading: true,
            formData: {
                startTime: '',
                endTime: ''
            },
            rules: {
                startTime: [
                    { validator: validStartTime, trigger: 'change' }
                ],
                endTime: [
                    { validator: validEndTime, trigger: 'change' }
                ]
            },
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.BILLS_CYCLE, false),
                    params: {
                        groupByFlag: 'cycle'
                    }
                },
                searchShow: true,
                columnsChooseShow: true,
                searchColumns: [],
                columns: []
            }
        }
    },
    created () {
        this.initColumns()
    },
    methods: {
        initColumns () {
            this.tableAttr.columns = this.columns
            this.tableAttr.searchColumns = this.searchColumns
            this.loading = false
        },
        clearDate () {
            this.$refs.form.resetFields()
            const params = { ...this.tableAttr.source.params }
            delete params.startTime
            delete params.endTime
            this.$refs.rcTable.refreshTable(params)
        },
        exportData () {
            const params = this.getTableParams()
            this.$emit('handleExport', params)
        },
        getTableParams () {
            const result = {}
            const searchList = this.$refs.rcTable.searchValueList || []
            if (searchList.length) {
                searchList.forEach(item => {
                    result[item.key] = item.value
                })
            }
            const params = this.dealDate()
            Object.assign(result, this.tableAttr.source.params, params)
            return result
        },
        downloadTask () {
            this.$emit('handleTask')
        },
        // 处理时间的格式，返回2021-04
        dealDate () {
            const { startTime, endTime } = this.formData
            let params = {}
            if (startTime && endTime) {
                params = {
                    startTime: formatDateTime(startTime).substr(0, 7),
                    endTime: formatDateTime(endTime).substr(0, 7)
                }
            }
            return params
        },
        submit () {
            this.$refs.form.validate(valid => {
                const { startTime, endTime } = this.formData
                if (!valid || !startTime || !endTime) return
                const params = this.dealDate()
                this.$refs.rcTable.refreshTable({ ...this.tableAttr.source.params, ...params })
            })
        },
        refresh () {
            this.$refs.rcTable.refreshTable()
        }
    }
}
</script>

<style lang="less" scoped>
.account-period {
    height: calc(~'100% - 55px');
    overflow: auto;
}
</style>
<style lang="less">
.billcycle-pack.account-period {
    .ivu-table-wrapper {
        overflow: visible;
    }
}
</style>
